import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.CustomAnalyticsCreate })));
const list = lazy(() => import("./List").then(m => ({ default: m.CustomAnalyticsList })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.CustomAnalyticsEdit })));

export default { create, list, edit };
